import { render, staticRenderFns } from "./allowance-back-pay.vue?vue&type=template&id=2e6a4d1d&"
import script from "./allowance-back-pay.vue?vue&type=script&lang=js&"
export * from "./allowance-back-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports